import { ReactNode } from "react";
import { DEFAULT_FONTSIZE } from "../utils/utils";
import Flex from "./Flex";
import Text from "./Text";
import { INPUT_FIELD_TEXT_SIZE } from "./app/provider/patient/chart/tokens";

interface ErrorHelperProps {
  children: ReactNode;
  label?: string;
  required?: boolean;
  error?: string | boolean;
}

const ErrorHelper = ({
  children,
  label,
  required,
  error,
}: ErrorHelperProps) => {
  return (
    <Flex flexDirection={"column"} height={"100%"} width={"inherit"}>
      {label && (
        <Text mb={"10px"} sx={DEFAULT_FONTSIZE}>
          {label}
          {required && (
            <Text fontSize={"13px"} component={"span"} color={"error"}>
              {` *`}
            </Text>
          )}
        </Text>
      )}
      {children}

      {!!error && (
        <Text fontSize={INPUT_FIELD_TEXT_SIZE} variant="caption" color="error">
          {error}
        </Text>
      )}
    </Flex>
  );
};

export default ErrorHelper;
